import { H2 } from 'UIComponents/elements/headings';
import * as React from 'react';
import { View } from 'foundations-components/transitional/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
const WalmartFilterBranchOperatorLabel = ({
  filterBranchOperator,
  large = false
}) => {
  return /*#__PURE__*/_jsx(View, {
    paddingBlock: "200",
    as: "div",
    children: large ? /*#__PURE__*/_jsx(H2, {
      children: filterBranchOperator
    }) : /*#__PURE__*/_jsx("b", {
      children: filterBranchOperator
    })
  });
};
export default WalmartFilterBranchOperatorLabel;